export function initDiagnosticDetails() {
    const diagnosticAlgorithmContainer = document.querySelector('.diagnostic-algorithm');
    const diagnosticDetailsContainer = document.querySelector('.diagnostic-details-container');

    if (!diagnosticAlgorithmContainer || !diagnosticDetailsContainer) {
        console.log('Diagnostic containers not found on this page, skipping initialization');
        return;
    }

    const parentElement = diagnosticAlgorithmContainer.parentElement;
    if (!parentElement) {
        console.log('Parent element for diagnostic algorithm not found, skipping initialization');
        return;
    }

    const carouselNavigation = parentElement.querySelector('.carousel-navigation');
    if (!carouselNavigation) {
        console.log('Carousel navigation not found, skipping initialization');
        return;
    }

    const prevBtn = carouselNavigation.querySelector('.carousel-button-prev');
    const nextBtn = carouselNavigation.querySelector('.carousel-button-next');

    if (!prevBtn || !nextBtn) {
        console.log('Navigation buttons not found, skipping initialization');
        return;
    }

    const items = Array.from(diagnosticAlgorithmContainer.children);

    if (items.length === 0) {
        console.log('No diagnostic items found, skipping initialization');
        return;
    }

    let currentIndex = 0;
    let isAnimating = false;
    let isMobile = window.innerWidth <= 768;
    let isTablet = window.innerWidth > 768 && window.innerWidth < 1024; // ИЗМЕНЕНО: < 1024 вместо <= 1024
    let isDesktop = window.innerWidth >= 1024; // ИЗМЕНЕНО: >= 1024 вместо > 1024
    let tabletStepElements = [];

    // Функция для изменения размера карточки diagnostic-step-others
    const resizeOthersCard = () => {
        if (window.innerWidth >= 1024) { // ИЗМЕНЕНО: >= 1024 вместо > 1024
            return;
        }
        const othersCard = document.querySelector('#diagnostic-step-others');
        if (othersCard) {
            let parentWidth;
            if (isMobile) {
                // Для мобильной версии используем ширину diagnostic-details-container
                parentWidth = diagnosticDetailsContainer.clientWidth;
            } else if (isTablet) {
                // Для планшета используем ширину diagnostic-algorithm
                parentWidth = diagnosticAlgorithmContainer.clientWidth;
            } else {
                // Для десктопа используем ширину diagnostic-algorithm
                parentWidth = diagnosticAlgorithmContainer.clientWidth;
            }

            // Учитываем отступы контейнера, если они есть
            const computedStyle = window.getComputedStyle(isMobile ? diagnosticDetailsContainer : diagnosticAlgorithmContainer);
            const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
            const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
            const targetWidth = parentWidth - paddingLeft - paddingRight;

            // Устанавливаем ширину в пикселях
            othersCard.style.width = `${targetWidth}px`;
            othersCard.style.maxWidth = 'none';
            othersCard.style.minWidth = 'auto';
            othersCard.classList.add('full-width-others');
        }
    };

    const checkDeviceType = () => {
        const wasMobile = isMobile;
        const wasTablet = isTablet;
        const wasDesktop = isDesktop;

        isMobile = window.innerWidth <= 768;
        isTablet = window.innerWidth > 768 && window.innerWidth < 1024; // ИЗМЕНЕНО: < 1024
        isDesktop = window.innerWidth >= 1024; // ИЗМЕНЕНО: >= 1024

        if (wasMobile !== isMobile || wasTablet !== isTablet || wasDesktop !== isDesktop) {
            initializeCarousel();
        }
        resizeOthersCard();
    };

    window.addEventListener('resize', checkDeviceType);

    const addAnimationStyles = () => {
        const style = document.createElement('style');
        style.textContent = `
            .diagnostic-details-container {
                position: relative;
                overflow: hidden;
            }
            
            @media (max-width: 768px) {
                .diagnostic-details-container {
                    overflow-x: auto;
                    overflow-y: hidden;
                    scroll-behavior: smooth;
                    -webkit-overflow-scrolling: touch;
                    scroll-snap-type: x mandatory;
                    padding-bottom: 10px;
                    margin-bottom: -10px;
                }
                
                .diagnostic-details-container::-webkit-scrollbar {
                    display: none;
                }
                
                .diagnostic-details-container {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                
                .diagnostic-details-mobile-wrapper {
                    display: flex;
                    gap: 15px;
                    width: fit-content;
                    padding: 0 20px;
                }
                
                .diagnostic-step-details {
                    min-width: 70vw;
                    max-width: 70vw;
                    scroll-snap-align: center;
                    flex-shrink: 0;
                }
                
                #diagnostic-step-others.diagnostic-step-details {
                    min-width: 0;
                    max-width: none;
                    flex-shrink: 0;
                }
                
                .carousel-navigation {
                    display: none !important;
                }
            }
            
            @media (min-width: 769px) and (max-width: 1023px) { /* ИЗМЕНЕНО: max-width 1023px вместо 1024px */
                .diagnostic-algorithm {
                    overflow-x: auto;
                    overflow-y: hidden;
                    scroll-behavior: smooth;
                    -webkit-overflow-scrolling: touch;
                    scroll-snap-type: x mandatory;
                    padding-bottom: 10px;
                    margin-bottom: -10px;
                }
                
                .diagnostic-algorithm::-webkit-scrollbar {
                    display: none;
                }
                
                .diagnostic-algorithm {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                
                .diagnostic-tablet-wrapper {
                    display: flex;
                    gap: 20px;
                    width: fit-content;
                    padding-right: 40px;
                }
                
                .diagnostic-step {
                    min-width: 350px;
                    max-width: 350px;
                    scroll-snap-align: start;
                    flex-shrink: 0;
                }
                
                #diagnostic-step-others.diagnostic-step {
                    min-width: 0;
                    max-width: none;
                    flex-shrink: 0;
                }
                
                .diagnostic-step.current-step-hidden {
                    display: none;
                }
                
                .diagnostic-step.full-width-tablet {
                    min-width: 100%;
                    max-width: 100%;
                    width: 100%;
                }
                
                .diagnostic-step.last-step-disabled {
                    cursor: default !important;
                    opacity: 0.8;
                    pointer-events: none;
                }
                
                .carousel-navigation {
                    display: none !important;
                }
                
                .diagnostic-step-details {
                    animation: fadeInFromRight 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
                
                .diagnostic-step-details.slide-out-left {
                    animation: fadeOutToLeft 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
                
                .diagnostic-step-details.slide-in-from-left {
                    animation: fadeInFromLeft 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
            }
            
            @media (min-width: 1024px) { /* ИЗМЕНЕНО: min-width 1024px вместо 1401px */
                .diagnostic-details-mobile-wrapper {
                    display: block;
                }
                
                .diagnostic-step-details {
                    animation: fadeInFromRight 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
                
                .diagnostic-step-details.slide-out-left {
                    animation: fadeOutToLeft 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
                
                .diagnostic-step-details.slide-in-from-left {
                    animation: fadeInFromLeft 0.6s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
                }
                
                #diagnostic-step-others {
                    min-width: 0;
                    max-width: none;
                }
            }
            
            .diagnostic-step {
                transition: all 0.5s cubic-bezier(0.4, 0.0, 0.2, 1);
                transform: translateX(0);
                opacity: 1;
            }
            
            .diagnostic-step.hidden {
                display: none;
            }
            
            .diagnostic-step.full-width {
                width: 100%;
            }
            
            .full-width-others {
                flex-shrink: 0;
            }
            
            .diagnostic-step.slide-fade-in {
                animation: slideFadeIn 0.5s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
            }
            
            .diagnostic-step.slide-fade-out {
                animation: slideFadeOut 0.5s cubic-bezier(0.4, 0.0, 0.2, 1) forwards;
            }
            
            .diagnostic-step-number {
                animation: pulseNumber 1s ease-in-out infinite;
            }
            
            .diagnostic-step-details .diagnostic-step-number {
                animation: rotateIn 1s cubic-bezier(0.4, 0.0, 0.2, 1) 0.3s both;
            }
            
            .diagnostic-step h4,
            .diagnostic-step-details h4 {
                animation: fadeInUp 0.8s cubic-bezier(0.4, 0.0, 0.2, 1) 0.4s both;
            }
            
            .diagnostic-step-details p {
                animation: fadeInUp 0.8s cubic-bezier(0.4, 0.0, 0.2, 1) 0.6s both;
            }
            
            @keyframes fadeInFromRight {
                from {
                    transform: translateX(100%);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes fadeOutToLeft {
                from {
                    transform: translateX(0);
                    opacity: 1;
                }
                to {
                    transform: translateX(-100%);
                    opacity: 0;
                }
            }
            
            @keyframes fadeInFromLeft {
                from {
                    transform: translateX(-100%);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes slideFadeIn {
                from {
                    transform: translateX(50px);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            
            @keyframes slideFadeOut {
                from {
                    transform: translateX(0);
                    opacity: 1;
                }
                to {
                    transform: translateX(-50px);
                    opacity: 0;
                }
            }
            
            @keyframes rotateIn {
                from {
                    transform: rotate(-180deg) scale(0);
                    opacity: 0;
                }
                to {
                    transform: rotate(0) scale(1);
                    opacity: 1;
                }
            }
            
            @keyframes fadeInUp {
                from {
                    transform: translateY(20px);
                    opacity: 0;
                }
                to {
                    transform: translateY(0);
                    opacity: 1;
                }
            }
            
            .diagnostic-step:not(.hidden):not(.current-step-hidden) {
                cursor: pointer;
                transition: all 0.3s ease;
            }
        `;
        document.head.appendChild(style);
    };

    function createMobileVersion() {
        diagnosticDetailsContainer.innerHTML = '';

        const mobileWrapper = document.createElement('div');
        mobileWrapper.classList.add('diagnostic-details-mobile-wrapper');

        items.forEach((item, index) => {
            const detailElement = item.cloneNode(true);
            detailElement.classList.remove('hidden', 'diagnostic-step', 'slide-fade-in', 'slide-fade-out');
            detailElement.classList.add('diagnostic-step-details', `background-${index + 1}`);
            mobileWrapper.appendChild(detailElement);
        });

        diagnosticDetailsContainer.appendChild(mobileWrapper);
        resizeOthersCard();

        diagnosticDetailsContainer.addEventListener('scroll', () => {
            const scrollPercent = diagnosticDetailsContainer.scrollLeft /
                (diagnosticDetailsContainer.scrollWidth - diagnosticDetailsContainer.clientWidth);
            const activeIndex = Math.round(scrollPercent * (items.length - 1));

            indicators.children[activeIndex]?.style.setProperty('background', '#19b5e1');
            indicators.children[activeIndex]?.style.setProperty('transform', 'scale(1.2)');

            Array.from(indicators.children).forEach((dot, index) => {
                if (index !== activeIndex) {
                    dot.style.setProperty('background', 'rgba(25, 181, 225, 0.3)');
                    dot.style.setProperty('transform', 'scale(1)');
                }
            });
            resizeOthersCard(); // Обновляем размер при скролле
        });
    }

    function createTabletVersion() {
        const existingIndicators = diagnosticDetailsContainer.parentElement.querySelector('.scroll-indicators');
        if (existingIndicators) {
            existingIndicators.remove();
        }

        diagnosticAlgorithmContainer.innerHTML = '';
        const tabletWrapper = document.createElement('div');
        tabletWrapper.classList.add('diagnostic-tablet-wrapper');

        tabletStepElements = [];
        items.forEach((item, index) => {
            const stepElement = item.cloneNode(true);
            stepElement.classList.remove('hidden', 'slide-fade-in', 'slide-fade-out');
            stepElement.dataset.index = index;
            tabletStepElements.push(stepElement);
            tabletWrapper.appendChild(stepElement);
        });

        diagnosticAlgorithmContainer.appendChild(tabletWrapper);
        resizeOthersCard();
        updateTabletDisplay();

        let scrollTimeout;
        diagnosticAlgorithmContainer.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                const stepWidth = 350 + 20;
                const scrollLeft = diagnosticAlgorithmContainer.scrollLeft;
                const newIndex = Math.round(scrollLeft / stepWidth);

                if (newIndex !== currentIndex && !isAnimating && newIndex >= 0 && newIndex < items.length) {
                    const direction = newIndex > currentIndex ? 'forward' : 'backward';
                    currentIndex = newIndex;
                    updateTabletDisplay(direction);
                }
                resizeOthersCard(); // Обновляем размер при скролле
            }, 100);
        });

        tabletStepElements.forEach((stepElement, index) => {
            stepElement.addEventListener('click', () => {
                if (index === items.length - 1) {
                    return;
                }

                if (!stepElement.classList.contains('current-step-hidden') && !isAnimating) {
                    const direction = index > currentIndex ? 'forward' : 'backward';
                    currentIndex = index;
                    updateTabletDisplay(direction);

                    const stepWidth = 350 + 20;
                    const targetScroll = index * stepWidth;
                    diagnosticAlgorithmContainer.scrollTo({
                        left: targetScroll,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    function updateTabletDisplay(direction = 'forward') {
        if (isAnimating) return;
        isAnimating = true;

        const currentDetail = diagnosticDetailsContainer.querySelector('.diagnostic-step-details');
        if (currentDetail) {
            if (direction === 'forward') {
                currentDetail.classList.add('slide-out-left');
            } else {
                currentDetail.classList.add('slide-out-right');
            }
        }

        tabletStepElements.forEach((stepElement, index) => {
            stepElement.classList.remove('current-step-hidden', 'full-width-tablet');

            if (index === currentIndex) {
                stepElement.classList.add('current-step-hidden');
            }

            if (currentIndex === items.length - 1 && index === items.length - 1) {
                stepElement.classList.remove('current-step-hidden');
                stepElement.classList.add('full-width-tablet');
            }
        });

        setTimeout(() => {
            diagnosticDetailsContainer.innerHTML = '';
            const detailElement = items[currentIndex].cloneNode(true);
            detailElement.classList.remove('hidden', 'diagnostic-step', 'slide-fade-in', 'slide-fade-out');
            detailElement.classList.add('diagnostic-step-details', `background-${currentIndex + 1}`);

            if (direction === 'backward') {
                detailElement.classList.add('slide-in-from-left');
            }

            diagnosticDetailsContainer.appendChild(detailElement);
            resizeOthersCard();

            setTimeout(() => {
                isAnimating = false;
            }, 600);
        }, 350);
    }

    function updateDisplay(direction = 'forward') {
        if (isAnimating) return;
        isAnimating = true;

        const currentDetail = diagnosticDetailsContainer.querySelector('.diagnostic-step-details');
        if (currentDetail) {
            if (direction === 'forward') {
                currentDetail.classList.add('slide-out-left');
            } else {
                currentDetail.classList.add('slide-out-right');
            }
        }

        items.forEach((item, index) => {
            let shouldBeVisible = false;

            if (currentIndex === items.length - 2) {
                shouldBeVisible = index === items.length - 1;
            } else {
                shouldBeVisible = index === currentIndex + 1 ||
                    (index === currentIndex + 2 && currentIndex + 2 < items.length);
            }

            if (!shouldBeVisible) {
                item.classList.add('hidden');
            }
        });

        setTimeout(() => {
            items.forEach((item, index) => {
                const wasVisible = !item.classList.contains('hidden');
                let shouldBeVisible = false;

                if (currentIndex === items.length - 2) {
                    shouldBeVisible = index === items.length - 1;
                } else {
                    shouldBeVisible = index === currentIndex + 1 ||
                        (index === currentIndex + 2 && currentIndex + 2 < items.length);
                }

                if (wasVisible && !shouldBeVisible) {
                    item.classList.remove('hidden');
                    item.classList.add('slide-fade-out');
                    setTimeout(() => {
                        item.classList.add('hidden');
                        item.classList.remove('slide-fade-out');
                    }, 500);
                } else if (!wasVisible && shouldBeVisible) {
                    item.classList.remove('hidden');
                    item.classList.add('slide-fade-in');
                    setTimeout(() => {
                        item.classList.remove('slide-fade-in');
                    }, 500);
                }

                if (currentIndex === items.length - 2 && index === items.length - 1) {
                    item.classList.add('full-width');
                } else {
                    item.classList.remove('full-width');
                }
            });
            resizeOthersCard();
        }, 50);

        setTimeout(() => {
            if (isDesktop) {
                diagnosticDetailsContainer.innerHTML = '';
                const detailElement = items[currentIndex].cloneNode(true);
                detailElement.classList.remove('hidden', 'diagnostic-step', 'slide-fade-in', 'slide-fade-out');
                detailElement.classList.add('diagnostic-step-details', `background-${currentIndex + 1}`);

                if (direction === 'backward') {
                    detailElement.classList.add('slide-in-from-left');
                }

                diagnosticDetailsContainer.appendChild(detailElement);
                resizeOthersCard();
            }

            setTimeout(() => {
                isAnimating = false;
            }, 600);
        }, 350);

        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === items.length - 2;
    }

    function initializeCarousel() {
        const existingIndicators = diagnosticDetailsContainer.parentElement.querySelector('.scroll-indicators');
        if (existingIndicators) {
            existingIndicators.remove();
        }

        currentIndex = 0;
        tabletStepElements = [];

        if (isMobile) {
            createMobileVersion();
            carouselNavigation.style.display = 'none';
        } else if (isTablet) {
            createTabletVersion();
            carouselNavigation.style.display = 'none';
        } else if (isDesktop) {
            diagnosticAlgorithmContainer.innerHTML = '';
            items.forEach(item => {
                diagnosticAlgorithmContainer.appendChild(item);
            });
            carouselNavigation.style.display = 'flex';
            updateDisplay();
        }
        resizeOthersCard();
    }

    items.forEach((item, index) => {
        item.addEventListener('click', () => {
            if (isDesktop && !item.classList.contains('hidden') && !isAnimating) {
                let targetIndex;
                if (currentIndex === items.length - 2) {
                    targetIndex = items.length - 2;
                } else {
                    if (item === items[currentIndex + 1]) {
                        targetIndex = currentIndex;
                    } else if (item === items[currentIndex + 2]) {
                        targetIndex = currentIndex + 1;
                    }
                }

                if (targetIndex !== undefined && targetIndex !== currentIndex) {
                    const direction = targetIndex > currentIndex ? 'forward' : 'backward';
                    currentIndex = targetIndex;
                    updateDisplay(direction);
                }
            }
        });
    });

    prevBtn.addEventListener('click', () => {
        if (isDesktop && currentIndex > 0 && !isAnimating) {
            currentIndex--;
            updateDisplay('backward');
        }
    });

    nextBtn.addEventListener('click', () => {
        if (isDesktop && currentIndex < items.length - 2 && !isAnimating) {
            currentIndex++;
            updateDisplay('forward');
        }
    });

    addAnimationStyles();
    initializeCarousel();

    console.log('Diagnostic details initialized successfully with mobile, tablet and desktop versions');
}